"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Clock = /** @class */ (function (_super) {
    __extends(Clock, _super);
    function Clock(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            dateTime: new Date()
        };
        _this.tick = function () {
            var newDateTime = Date.now() - _this.delta;
            _this.setState({ dateTime: new Date(newDateTime) }, function () {
                // If it was just `setInterval` of 1000ms, there'd be a couple of problems:
                // - Sometimes, a second could be "skipped" because `setInterval` isn't very precise
                // - It could start at the "middle" of the second (like, "10:52:30.789"), which won't be in sync with the system clock
                // To mitigate this, we calculate how many miliseconds there is until the next second and schedule the next update based on that
                var msUntilNextSec = 1000 - (Date.now() % 1000);
                _this.timeoutId = setTimeout(_this.tick, msUntilNextSec);
            });
        };
        _this.delta = props.initialDateTime
            ? Date.now() - props.initialDateTime.getTime()
            : 0;
        return _this;
    }
    Clock.prototype.componentDidMount = function () {
        this.tick();
    };
    Clock.prototype.componentWillUnmount = function () {
        clearTimeout(this.timeoutId);
    };
    Clock.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.forceUpdateInitialDateTime &&
            prevProps.initialDateTime != this.props.initialDateTime) {
            this.delta = this.props.initialDateTime
                ? Date.now() - this.props.initialDateTime.getTime()
                : 0;
        }
    };
    Clock.prototype.render = function () {
        return this.props.children(this.state.dateTime);
    };
    return Clock;
}(React.Component));
exports.default = Clock;
